import { Environment } from '@ot/shared/utils';
import '@ot/shared/global-navigation-prod';

// bracket notation does not work with aot, e.g [IftaServiceName.FilingService]: `${iftaBaseUrl}/ifta-orchestration`
// https://angular.io/guide/aot-metadata-errors#expression-form-not-supported
export const environment: Environment = {
  production: true,
  appName: 'ifta',
  // TODO actually point to a prod-like url
  baseUrl: '',
  serviceUrlList: {
    // TODO remove me
    businessAccountService: 'business-acct-service/v2',
    filingService: `ifta-orchestration`,
    iftaConstantsService: `ifta-constants`,
    distanceService: `distance-crud`,
    fuelReceiptService: `fuel-receipt-crud`,
    taxAccountService: `tax-account-service/v2`,
    vehicleTaxAccountService: `vehicle-tax-account-service/v2`,
    userService: `user-service/v1`,
    reportingService: `report-service/v1`,
    vehicleService: `vehicle-service/v1`
  }
};
